module.exports = __webpack_public_path__ + "img/bocata.9b553bf0.jpg";